// constants.js
export const DEFAULT_ACTION_TEXT = "Ok";
export const COPIED_TIMEOUT = 1200;
export const BACKDROP_KEYS = ["Enter", " ", "Spacebar", "Escape"];
